import React, { ReactNode } from "react";
import { getClassNames } from "../../utils";
import "./FormGroup.css";
import withTheme from "../../hocs/withTheme";

type FormGroupProps = {
    disabled?: boolean;
    focused?: boolean;
    opened?: boolean;
    error?: boolean | string;
    children?: ReactNode;
    className?: string;
};

function FormGroup({
    disabled = false,
    focused = false,
    opened = false,
    error = false,
    children = null,
    className = '',
} : FormGroupProps) {
    const formGroupClassName = getClassNames(
        "form-group",
        className,
        { "form-group_focused": focused },
        { "form-group_opened": opened },
        { "form-group_disabled": disabled },
        { "form-group_invalid": error }
    );

    return <div className={formGroupClassName}>{children}</div>;
}

export default withTheme(FormGroup);
